import React from 'react';
import {
  gridPageCountSelector,
  GridPagination,
  useGridApiContext,
  useGridSelector,
} from '@mui/x-data-grid-pro';
import { Select, MenuItem, Box } from '@mui/material';

function CustomPagination() {
  const apiRef = useGridApiContext();
  const page = useGridSelector(apiRef, (state) => state.pagination.paginationModel.page);
  const pageCount = useGridSelector(apiRef, gridPageCountSelector);

  const handlePageChange = (event) => {
    const newPage = parseInt(event.target.value, 10);
    apiRef.current.setPage(newPage);
    // Nu salvăm în localStorage - utilizatorul vrea să înceapă de la început când revine
  };

  // Generează lista de pagini
  const pageOptions = [];
  for (let i = 0; i < pageCount; i++) {
    pageOptions.push(i);
  }

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      {pageCount > 1 && (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <span style={{ fontSize: '13px', color: '#666' }}>Pagina:</span>
          <Select
            value={page}
            onChange={handlePageChange}
            size="small"
            sx={{ 
              minWidth: 60,
              height: 28,
              fontSize: '13px',
              '& .MuiSelect-select': {
                paddingTop: '4px',
                paddingBottom: '4px',
                paddingLeft: '8px',
                paddingRight: '24px',
              },
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: '#d0d0d0',
              },
              '&:hover .MuiOutlinedInput-notchedOutline': {
                borderColor: '#999',
              },
            }}
            MenuProps={{
              PaperProps: {
                sx: {
                  maxHeight: 300,
                  '& .MuiMenuItem-root': {
                    fontSize: '13px',
                    minHeight: '32px',
                    paddingTop: '4px',
                    paddingBottom: '4px',
                  },
                },
              },
            }}
          >
            {pageOptions.map((pageNum) => (
              <MenuItem key={pageNum} value={pageNum}>
                {pageNum + 1}
              </MenuItem>
            ))}
          </Select>
        </Box>
      )}
      <GridPagination />
    </Box>
  );
}

export default CustomPagination;
